import GroupsAutoSuggestContainer from './GroupsAutoSuggestContainer';

export default GroupsAutoSuggestContainer;
